import { render, staticRenderFns } from "./GiftIcon.vue?vue&type=template&id=393ce8fe&scoped=true"
import script from "./GiftIcon.vue?vue&type=script&lang=js"
export * from "./GiftIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393ce8fe",
  null
  
)

export default component.exports